exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".survey-explanation[data-v-00ed1736] {\n  font-size: 1.2rem;\n  border-left: 8px solid #5A4587;\n  border-bottom: 3px solid #5A4587;\n}\n", ""]);

// exports
